<div class="donut-chart">
  @if (options) {
  <div
    #chartContainer
    echarts
    [options]="options"
    (chartClick)="onChartClick($event)"
    (contextmenu)="onChartContextMenu($event)"
    (chartInit)="onChartInit($event)"
    class="donut-chart__plot"
  ></div>

  @if (legendItems.length) {
  <div class="donut-chart__legend">
    @for (row of legendRows; track $index) {
    <div class="donut-chart__legend-row">
      @for (item of row; track item.name) {
      <div class="donut-chart__legend-item" [title]="item.name">
        <span class="donut-chart__legend-dot" [style.background]="item.color"></span>
        <span class="donut-chart__legend-label">{{ item.name }}</span>
      </div>
      }
    </div>
    }
  </div>
  }

  }
</div>
